import React, { useEffect, useState } from 'react';
import "../../../Assets/Css/Document.scss";
import Table from '../../../Components/Table';
import moment from 'moment';
import AddDocumentModal from '../../../Components/AddDocumentModal';
import { connect } from 'react-redux';
import { addDocument, getDocuments } from '../../../Services/Document/action';
import { deleteRecord } from '../../../Services/Delete/action';
import { getUsers } from '../../../Services/Users/action';
import RoleWiseFeatureWrapper, { checkFeatureAccess } from '../../../Lib/RoleWiseFeatureWrapper';
import ModulesList from '../../../Assets/ModulesLiist';
import FeaturesList from '../../../Assets/FeaturesList';
import { toast } from 'react-toastify';
import { useLocation, useParams } from 'react-router-dom';

const EmployeeDocuments = (props) => {
     const location = useLocation();
     const [files, setFiles] = useState([]);
     const [previews, setPreviews] = useState([]);
     const [showModal, setShowModal] = useState(false);
     const [inData, setInData] = useState([]);
     const [fileType, setFileType] = useState('');
     const { employeeId } = useParams();
     const header = [
          { field: 'File' },
          { field: 'Name' },
          { field: 'Date' },
          { field: 'Action' }
     ];
     const canView = checkFeatureAccess({
          modules: props?.modules,
          features: props?.features,
          user: props?.user,
          ModuleName: ModulesList.Documents,
          Featur_Name: FeaturesList.View,
     });

     const canDelete = checkFeatureAccess({
          modules: props?.modules,
          features: props?.features,
          user: props?.user,
          ModuleName: ModulesList.Documents,
          Featur_Name: FeaturesList.Delete,
     });

     useEffect(() => {
          const fetchData = async () => {
               await props?.getDocuments();
          }

          fetchData();
     }, [location.search])

     useEffect(() => {
          const updateContent = async () => {
               const content = await Promise.all(
                    props?.document
                         ?.filter((doc) => doc?.employee_id == employeeId)
                         ?.map((item) => {
                              try {
                                   let url;
                                   const byteArray = new Uint8Array(item.document.data);
                                   const stringData = new TextDecoder().decode(byteArray);

                                   let base64String = '';
                                   let mimeType = '';

                                   if (stringData.startsWith('data:')) {
                                        const match = stringData.match(/^data:(.*?);base64,(.*)$/);
                                        if (match) {
                                             mimeType = match[1];
                                             base64String = match[2];
                                        }
                                   } else {
                                        mimeType = 'application/pdf';
                                        base64String = btoa(String.fromCharCode(...byteArray));
                                   }

                                   const binaryString = atob(base64String);
                                   const len = binaryString.length;
                                   const bytes = new Uint8Array(len);
                                   for (let i = 0; i < len; i++) {
                                        bytes[i] = binaryString.charCodeAt(i);
                                   }

                                   const blob = new Blob([bytes], { type: mimeType });
                                   url = URL.createObjectURL(blob);


                                   return {
                                        File: {
                                             value: item?.name,
                                             type: 'documents',
                                        },
                                        Name: {
                                             value: item?.name,
                                             type: 'text',
                                        },
                                        Date: {
                                             value: moment(item?.createdAt).format('DD-MM-YYYY'),
                                             type: 'date',
                                        },
                                        Action: {
                                             value: '/document/edit',
                                             value2: `/employees/view/${employeeId}/document/view`,
                                             value1: url,
                                             value3: item?.id,
                                             fileName: `${item?.name?.split(".")[0]}_${item?.doc_type}`,
                                             type: 'action',
                                        },
                                        allData: {
                                             ...item
                                        }
                                   }
                              } catch (error) {
                                   console.error('Failed Processing document:', error);
                              }
                         }))
               setInData(content);
          }

          if (props?.document?.length) {
               updateContent()
          }
     }, [props?.document]);

     const handleFileChange = (event) => {
          if (files.length > 0) {
               toast.error("You can upload only one file. Please remove the existing one first.");
               return;
          }
          const newFiles = Array.from(event.target.files);
          const newPreviews = newFiles.map(file => URL.createObjectURL(file));

          setFiles(prevFiles => [...prevFiles, ...newFiles]);
          setPreviews(prevPreviews => [...prevPreviews, ...newPreviews]);
     };

     const isOpen = () => {
          setShowModal(true);
     }
     const onClose = () => {
          setShowModal(false);
          setFileType('');
          setFiles([]);
          setPreviews([]);
     }

     useEffect(() => {
          return () => {
               previews.forEach(preview => URL.revokeObjectURL(preview));
          };
     }, [previews]);

     const handleRemoveFile = (index) => {
          setFiles(files.filter((_, i) => i !== index));
          setPreviews(previews.filter((_, i) => i !== index));
     };

     const fileToBase64 = (file) => {
          return new Promise((resolve, reject) => {
               const reader = new FileReader();
               reader.readAsDataURL(file); // Encodes file as Base64
               reader.onload = () => resolve(reader.result);
               reader.onerror = (error) => reject(error);
          });
     };

     const handleAdd = async () => {
          try {
               const file = files[0];
               const base64File = await fileToBase64(file);
               const body = {
                    name: file?.name,
                    document: base64File,
                    doc_type: fileType?.val?.value,
                    employee_id: employeeId
               }
               await props?.addDocument(body);
               onClose();
          } catch (error) {
               console.error("Error adding document:", error);
          }
     }


     return (
          <div className='document-container'>
               <div className='add-document-button mb-4'>
                    <RoleWiseFeatureWrapper
                         modules={props?.modules}
                         features={props?.features}
                         user={props?.user}
                         ModuleName={ModulesList.Documents}
                         Featur_Name={FeaturesList.Create}>

                         <button className="custom-btn" data-toggle="modal" data-target="#exampleModal" onClick={isOpen}>
                              Add Document
                         </button>
                    </RoleWiseFeatureWrapper>
               </div>

               <div className='common-card'>
                    <Table
                         header={header}
                         data={inData}
                         count={inData?.length}
                         showIsView={canView}
                         showIsDownload={true}
                         showIsDelete={canDelete}
                         deleteRecord={props?.deleteRecord}
                    />
               </div>

               <AddDocumentModal showModal={showModal} onClose={onClose} handleRemoveFile={handleRemoveFile} previews={previews} handleFileChange={handleFileChange} handleAdd={handleAdd} fileType={fileType} setFileType={setFileType} files={files} />
          </div>
     );
};

const mapStateToProps = (state) => {
     return {
          loading: state.documentReducer.loading,
          project: state.projectReducer.project,
          document: state.documentReducer.document,
          modules: state.authenticationReducer.modules,
          features: state.authenticationReducer.features,
          user: state.authenticationReducer.user,
          addDocument: state.documentReducer.addDocument
     }
}

const mapDispatchToProps = (dispatch) => {
     return {
          getUsers: () => {
               dispatch(getUsers());
          },
          getDocuments: () => {
               dispatch(getDocuments());
          },
          addDocument: (data) => {
               dispatch(addDocument(data));
          },
          deleteRecord: async (id, inputValue) => {
               await dispatch(deleteRecord(id, inputValue));
               await dispatch(getDocuments());
          }
     }
}

export default connect(mapStateToProps, mapDispatchToProps)(EmployeeDocuments);
